import { scrollToWhenReady } from '@shared/hooks/helpers/scrollToWhenReady';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

export function useScrollToQueryParam() {
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const id = searchParams.get('scrollToId');
        if (!id) return;

        scrollToWhenReady(id, {
            // Allow a few seconds for the target to mount on slower routes.
            maxAttempts: 180,
            onReveal: () => {
                // Remove `scrollToId` from the URL without adding a history entry.
                setSearchParams(
                    (prevParams) => {
                        const newParams = new URLSearchParams(prevParams);
                        newParams.delete('scrollToId');
                        return newParams;
                    },
                    { replace: true }
                );
            },
        });
    }, [searchParams, setSearchParams]);

    return null;
}
